import { render, staticRenderFns } from "./ProjectContact.vue?vue&type=template&id=636fddf4&"
import script from "./ProjectContact.vue?vue&type=script&lang=js&"
export * from "./ProjectContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('636fddf4')) {
      api.createRecord('636fddf4', component.options)
    } else {
      api.reload('636fddf4', component.options)
    }
    module.hot.accept("./ProjectContact.vue?vue&type=template&id=636fddf4&", function () {
      api.rerender('636fddf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/ProjectContact.vue"
export default component.exports